import type { DataType } from '@/types'
import type { ApiSchema, DeploymentRegion } from '@klarna/cbrms-policy-rules-manager-client-ts'

export const dataTypes: DataType[] = ['str', 'bool', 'int', 'float', 'dict', 'list']

// We derive the apiSchemas array from the apiSchemasMap to not to forget to add them
// Typescript will throw an error if one of the keys is not included in apiSchemasMap object
const apiSchemasMap: Record<ApiSchema, ApiSchema> = {
  alternative_payments_risk: 'alternative_payments_risk',
  aml_transaction_monitoring: 'aml_transaction_monitoring',
  basic_policy_api: 'basic_policy_api',
  card_transaction_risk: 'card_transaction_risk',
  card_transaction_risk_authentication: 'card_transaction_risk_authentication',
  chargeback: 'chargeback',
  cobra: 'cobra',
  dunning_personalization_engine: 'dunning_personalization_engine',
  electronic_id_issuing_risk: 'electronic_id_issuing_risk',
  fraud_disputes: 'fraud_disputes',
  fraud_ds_apm: 'fraud_ds_apm',
  instant_refunds: 'instant_refunds',
  klarna_app_login: 'klarna_app_login',
  klarna_card_issuing: 'klarna_card_issuing',
  perfect_offer: 'perfect_offer',
  personal_details_update: 'personal_details_update',
  preauth_risk: 'preauth_risk',
  returning_customer: 'returning_customer',
  settlement_abuse_risk: 'settlement_abuse_risk',
  unbranded_card_risk_assess: 'unbranded_card_risk_assess',
  user_account_creation: 'user_account_creation',
  kyc_decision: 'kyc_decision',
}

export const apiSchemas: ApiSchema[] = Object.values(apiSchemasMap)

export const EXTENSIONS_OPEN_TO_OWNERS_APIS: ApiSchema[] = ['perfect_offer']

export const LATEST_SUPPORTED_RULE_FORMAT_VERSION = 1

export const LATEST_SUPPORTED_POLICY_FORMAT_VERSION = 1

export const LATEST_SUPPORTED_USER_FUNCTION_FORMAT_VERSION = 1

export const regions: DeploymentRegion[] = ['EU', 'US', 'AP']
